import { render, staticRenderFns } from "./PageSeoSettings.vue?vue&type=template&id=44d46f81"
import script from "./PageSeoSettings.vue?vue&type=script&lang=js"
export * from "./PageSeoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports